/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_RemainingInputs */

const en_settings_credits_remaining = /** @type {(inputs: Settings_Credits_RemainingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remaining`)
};

/**
* | output |
* | --- |
* | "Remaining" |
*
* @param {Settings_Credits_RemainingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_credits_remaining = /** @type {((inputs?: Settings_Credits_RemainingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_RemainingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_credits_remaining(inputs)
});
export { settings_credits_remaining as "settings.credits.remaining" }